import {
  VStack,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  Icon,
  Text,
} from '@chakra-ui/react';

import { IoAlertCircleOutline } from 'react-icons/io5';

import { TaxInfo } from '~/types/cart';

type CompanyTaxFormProps = {
  taxInfo: TaxInfo;
  errors?: TaxInfo;
  onChangeTaxTitle?: (title: string) => void;
  onChangeTaxInvoice?: (invoice: string) => void;
  isReadOnly?: boolean;
};

export default function CompanyTaxForm({
  taxInfo,
  errors,
  onChangeTaxInvoice,
  onChangeTaxTitle,
  isReadOnly = false,
}: CompanyTaxFormProps) {
  return (
    <VStack spacing={4} width="100%">
      <FormControl isRequired isInvalid={!!errors?.title} isReadOnly={isReadOnly}>
        <FormLabel fontSize="sm" fontWeight="normal">
          抬頭
        </FormLabel>
        <Input
          value={taxInfo.title}
          type="text"
          onChange={(e) => onChangeTaxTitle?.(e.target.value)}
        />
        <FormErrorMessage borderRadius="5px" bgColor="danger.200" p={2}>
          <Icon as={IoAlertCircleOutline} color="danger.600" boxSize="1.5rem" mr={1} />
          <Text color="danger.600">{errors?.title || ''}</Text>
        </FormErrorMessage>
      </FormControl>

      <FormControl isRequired isInvalid={!!errors?.invoice} isReadOnly={isReadOnly}>
        <FormLabel fontSize="sm" fontWeight="normal">
          統編
        </FormLabel>
        <Input
          value={taxInfo.invoice}
          type="number"
          inputMode="numeric"
          onChange={(e) => onChangeTaxInvoice?.(e.target.value)}
        />

        <FormErrorMessage borderRadius="5px" bgColor="danger.200" p={2}>
          <Icon as={IoAlertCircleOutline} color="danger.600" boxSize="1.5rem" mr={1} />
          <Text color="danger.600">{errors?.invoice || ''}</Text>
        </FormErrorMessage>
      </FormControl>
    </VStack>
  );
}
